const mapSetsForCompetitor = (side, periods = {}) => {
  const periodKeys = Object.keys(periods).sort((a, b) => {
    const aNum = Number(String(a).replace(/\D/g, '')) || 0;
    const bNum = Number(String(b).replace(/\D/g, '')) || 0;
    return aNum - bNum;
  });

  return periodKeys
    .map(key => periods[key]?.[side])
    .filter(value => value !== undefined && value !== null);
};

const buildAbbreviationFromName = (name = '') => (
  name
    .split('/')
    .map(part => part.trim()[0] || '')
    .filter(Boolean)
    .join('/')
    .toUpperCase()
);

const resolveTeamName = team => {
  const name = team?.name || '';
  const abbr = team?.abbr || '';

  if (!name.includes('/')) {
    return name;
  }

  if (abbr.includes('/')) {
    return abbr.toUpperCase();
  }

  return buildAbbreviationFromName(name);
};

const mapCompetitors = (match, market) => {
  const homeName = match?.teams?.home?.name || '';
  const awayName = match?.teams?.away?.name || '';

  // Optional usage and construction of abbr possible
  // const homeName = resolveTeamName(match?.teams?.home);
  // const awayName = resolveTeamName(match?.teams?.away);

  const outcomes = market?.outcomes || [];
  const hasOdds = outcomes.length > 0;
  const homeOutcome = outcomes[0] || {};
  const awayOutcome = outcomes[1] || {};

  return [
    {
      name: homeName,
      sets: mapSetsForCompetitor('home', match?.periods),
      odds: hasOdds ? (homeOutcome.odds ?? '-') : null,
    },
    {
      name: awayName,
      sets: mapSetsForCompetitor('away', match?.periods),
      odds: hasOdds ? (awayOutcome.odds ?? '-') : null,
    },
  ];
};

const mapStatus = match => {
  if (match?.isLive) {
    return {
      status: 'isLive',
      statusLabelTranslationKey: 't_general_live',
      statusLabelValue: '',
    };
  } else {
    return {
      status: 'isNotStarted',
      statusLabelTranslationKey: 't_footer_match_tickers_starts_at',
      statusLabelValue: ` ${match?.startTime || ''}`,
    };
  }
};

// Build top label when matches belong to different tournaments
const buildTournamentHeader = (matches = []) => {
  const uniqueNames = [...new Set(matches.map(m => m?.tournamentName).filter(Boolean))];

  if (!uniqueNames.length) {
    return {
      translationKey: 't_footer_match_tickers_more_matches',
      name: '',
    };
  }

  return {
    translationKey: 't_footer_match_tickers_more_matches_in',
    name: uniqueNames.join(' / '),
  };
};

const mapFourSightTennisMatches = (rawMatches = []) => {
  const mappedMatches = rawMatches.map(match => {
    const market = match?.oddsMarkets?.[0] || null;
    const statusData = mapStatus(match);
    const hasOdds = Boolean(market?.outcomes?.length);

    return {
      matchId: match?.matchId || '',
      tournamentName: match?.tournamentName || '',
      isLive: match.isLive,
      statusLabelTranslationKey: statusData.statusLabelTranslationKey,
      statusLabelValue: statusData.statusLabelValue,
      currentSet: match?.currentSet || null,
      hasOdds,
      competitors: mapCompetitors(match, market),
    };
  });

  return {
    title: buildTournamentHeader(rawMatches),
    matches: mappedMatches,
  };
};

export default mapFourSightTennisMatches;
